export default "__VITE_ASSET__97965e48__"